<template>
  <div class="item">
    <div class="item-content">
      <div content="role">
        <p
          :class="{
            unknown: !item.role
          }">
          <b>{{ roleName || 'N/A' }}</b>
        </p>
        <p v-if="user" class="subtitle">
          {{ user.firstName }} {{ user.lastName }}
        </p>
      </div>
      <hr/>
      <div v-if="user" content="contact">
        <p>
          {{ mobileNo || 'N/A' }}
        </p>
        <p v-if="user.email">
          {{ user.email }}
        </p>
      </div>
      <hr/>
    </div>
    <div class="item-action">
      <el-button
        type="sc-asset"
        icon="
          el-icon-edit
        "
        @click="
          () => $emit('edit', item)
        ">
        แก้ไข
      </el-button>
      <el-button
        type="danger"
        icon="
          el-icon-s-release
        "
        @click="
          () => $emit('remove-role', item)
        ">
        ลบสถานะ
      </el-button>
    </div>
  </div>
</template>
<script lang="js">

// Common
import {
  NonScCommon as Common
} from '../../common/nonsc.common'

import {
  NonScUserRoleCommon as RoleCommon, RoleItem
} from '../../common/nonsc-user-role.common'

export default {
  props: {
    role: {
      type: Object,
      default: () => RoleCommon.item
    }
  },
  data() {
    
    /** @type {RoleItem} */
    const item = (
      Object.assign({}, RoleCommon.item)
    )

    return {
      item,
      confirm: {
        open: true
      },
    }
  },
  computed: {
    roleName() {
      
      // Validate Item
      if (!this.item) return

      // Set Role
      const role = (
        Common.setRole(this.item.role)
      )

      // Set Role Name
      if (role) return role.name
    },
    mobileNo() {
      return (
        Common.toMobileNo(this.user.mobileNo)
      )
    },
    user() {
      return (
        this.item ? this.item.user : RoleCommon.user
      )
    },
  },
  watch: {
    role: {
      handler(value) {
        this.setItem(value)
      },
      deep: true
    }
  },
  mounted() {
    this.item = this.role
  },
  methods: {
    setItem(value) {
      
      // Validate Value
      if (!value) return
      
      // Set Item
      this.item = (
        Object.assign({}, RoleCommon.item, value)
      )
    }
  }
}
</script>

<style lang="css" scoped>

.item {
  gap         : var(--size-sm);
  padding     : var(--size-sm) var(--size-md);
  align-items : center;
}

.item-content {
  flex        : 1;
  display     : flex;
  gap         : var(--size-sm);
  align-items : center;
}
.item-content hr {
  display: none;
}

[content=role],
[content=name] {
  flex: 1;
}
[content=contact] {
  flex: 1;
}

.item-action {
  display : flex;
  gap     : var(--size-sm);
}

@media screen and (max-width: 1280px) {

  .item {
    padding: var(--size-md);
  }
  .item,
  .item-content {
    flex-direction: column;
  }
  .item-content {
    align-items: flex-start;
  }
  .item-content hr {
    display: block;
  }
  .item-content,
  .item-action {
    width: 100%;
  }
  .item-action {
    justify-content: flex-end
  }
}

</style>


// WEBPACK FOOTER //
// src/features/nonsc/pages/home/NonScHomeRoleItem.vue